import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { Container } from '../global'

const Footer = () => (
  <FooterWrapper id="footer">
    <FooterColumnContainer>
      <FooterColumn>
        <StyledLink to="/credits">
          <span>Credits</span>
        </StyledLink>
      </FooterColumn>
      <FooterColumn>
        <StyledLink to="/mission">
          <span>Mission</span>
        </StyledLink>
      </FooterColumn>
    </FooterColumnContainer>
  </FooterWrapper>
)

const FooterWrapper = styled.footer`
  background-color: ${props => props.theme.color.background.light};
  padding: 40px 40px;
`

const FooterColumnContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${props => props.theme.screen.xs}) {
    padding: 0 20px;
  }
`
const FooterColumn = styled.div`
  justify-self: center;
  span {
    font-size: 16px;
    font-family: ${props => props.theme.font.bold};
    color: ${props => props.theme.color.primary};
  }
`

export const StyledLink = styled(Link)`
  color: ${props => props.theme.color.primary};
  text-decoration: none;
`

export default Footer
